import React from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { roommemberApi } from '../../../apis/roommember/roommemberApi';
import icon05 from '../../../assets/images/ROOM_TaskFile_Re_05.png';
import { RoomMember } from '../../../types/types';
import {logError} from "../../../libs/utils/logError";
import useAppRouter from "../../../hooks/useAppRouter";

interface StopRoomMemberModalProps {
  roomMember: RoomMember;
  onSubmitted: () => Promise<void>;
}

export const StopRoomMemberModal = (props: StopRoomMemberModalProps) => {
  const { roomMember, onSubmitted } = props;
  const [disabled, setDisabled] = React.useState<boolean>(false);
  const location = useLocation();
  const { goto } = useAppRouter();

  const handleSubmit = async () => {
    setDisabled(true);
    try {
      await roommemberApi.stop({ userId: roomMember.id }, {});
      setDisabled(false);
      await onSubmitted();
    } catch(e) {
      await logError(
        location.pathname,
        'アカウントの停止に失敗しました。',
        e
      );

      goto('internalServerError');
    }
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted()}
        className="content"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">参加者の停止</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => onSubmitted()}
            >
              <img src={icon05} alt="icon" />
            </button>
          </div>
          <div className="form-modal-content text-center">
            <h1 className="text-primary text-xl font-semibold">
              {`「${roomMember.name}」を停止しますか？`}
            </h1>
          </div>
          <div className="form-modal-footer-container">
            <div className="form-modal-footer">
              <button
                className="btn-sub"
                type="button"
                onClick={() => onSubmitted()}
              >
                キャンセル
              </button>
              <button
                className="btn-primary"
                type="button"
                onClick={handleSubmit}
                disabled={disabled}
              >
                {disabled ? (
                  <>
                    <FontAwesomeIcon
                      icon={faSpinner}
                      className="animate-spin mr-4"
                    />
                    停 止
                  </>
                ) : (
                  '停　止'
                )}
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
